// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__DrhaO","inputDescription":"styles_inputDescription__3l-BZ"};